import {bufferTime, catchError, distinct, filter, first, groupBy, map, mapTo, mergeMap, tap} from "rxjs/operators";
import {of} from 'rxjs';
import {networkError} from "../actions/ui";
import {combineEpics, ofType} from "redux-observable";
import {
  API_GET_TASK,
  API_GET_TASK_DONE,
  API_GET_TASKS,
  API_GET_TASKS_DONE,
  getTaskDone,
  getTasks,
  getTasksDone
} from "../actions/tasks";
import * as R from 'ramda';
import {getTasks$, getTasksMulti$} from "../services/projects";
import {
  catchErrorsandResume,
  INDIVIDUAL_ID_BUFFER_MS,
  INDIVIDUAL_ID_FETCH_SIZE,
  MODEL_INSERTION_BUFFER_INTERVAL_MS,
  requestDedupInterval$
} from "./index";
import {injectSubview, setSubview, setSubviewCache} from "../actions/view";

const SVCLF = setSubviewCache({ loading: false });

const beginLoading = action$ => action$.pipe(
  ofType(API_GET_TASK),
  bufferTime(INDIVIDUAL_ID_BUFFER_MS, null, INDIVIDUAL_ID_FETCH_SIZE),
  filter(actions => actions.length > 0),
  first(),
  mapTo(setSubviewCache({ loading: true })),
  catchErrorsandResume(20066)
);

const endLoading = action$ => action$.pipe(
  ofType(API_GET_TASK_DONE, API_GET_TASKS_DONE),
  bufferTime(INDIVIDUAL_ID_BUFFER_MS, null, INDIVIDUAL_ID_FETCH_SIZE),
  filter(actions => actions.length > 0),
  first(),
  mapTo(setSubviewCache({ loading: false })),
  catchErrorsandResume(20067)
);

const getSingleEpic = action$ => action$.pipe(
  ofType(API_GET_TASK),
  mergeMap(action => getTasks$({ id: action.payload.id, projectId: action.payload.projectId }).pipe(
    map(({response}) => getTaskDone(response)),
    catchError(error => of(SVCLF, networkError({...error, number: '10103-'+error.status})))
  )),
  catchErrorsandResume(20070)
);

const getSingleMulti = action$ => action$.pipe(
  ofType(API_GET_TASK),
  groupBy(action => action.payload.projectId),
  mergeMap(group$ => group$.pipe(
    distinct(action => action.payload.id, requestDedupInterval$),
    bufferTime(INDIVIDUAL_ID_BUFFER_MS, null, INDIVIDUAL_ID_FETCH_SIZE),
    filter(actions => actions.length > 0),
    mergeMap(actions => getTasksMulti$({ projectId: actions[0].payload.projectId, ids: actions.map(action => action.payload.id )}).pipe(
      filter(({ response }) => response && response['results']),
      map(({ response }) => setSubview(response.results)),
      catchError(error => of(SVCLF, networkError({...error, number: '10104-'+error.status}))),
    )),
    catchError(error => of(SVCLF, networkError({...error, number: '10105-'+error.status}))),
  )),
  catchErrorsandResume(20071)
);

const processSingleEpic = action$ => action$.pipe(
  ofType(API_GET_TASK_DONE),
  map(action => action.payload),
  bufferTime(MODEL_INSERTION_BUFFER_INTERVAL_MS),
  filter(results => results.length > 0),
  tap(tasks => tasks[0].callback && tasks[0].callback(tasks[0].response.resource.id)),
  map(results => results.map(task => task.response)),
  map(results => setSubview(results)),
  catchErrorsandResume(20073)
);

const getMultipleEpic = action$ => action$.pipe(
  ofType(API_GET_TASKS),
  mergeMap(action => getTasks$({ id: action.payload.id, projectId: action.payload.projectId, offset: action.payload.offset }).pipe(
    map(({response}) => getTasksDone(response)),
    catchError(error => of(SVCLF, networkError({...error, number: '10106-'+error.status})))
  )),
  catchErrorsandResume(20069)
);

const processMultipleEpic = action$ => action$.pipe(
  ofType(API_GET_TASKS_DONE),
  filter(action => action.payload && action.payload.results),
  map(action => action.payload.results),
  bufferTime(MODEL_INSERTION_BUFFER_INTERVAL_MS),
  map(results => R.unnest(results)),
  filter(results => results.length > 0),
  map(results => injectSubview(results)),
  catchErrorsandResume(20072)
);

const getMoreEpic = action$ => action$.pipe(
  ofType(API_GET_TASKS_DONE),
  filter(action => action.payload && action.payload.results && action.payload.results.length === action.payload.limit),
  map(action => getTasks(action.payload.results.slice(-1)[0].resource.projectid, action.payload.results.slice(-1)[0].resource.id)),
  catchErrorsandResume(20068)
);

export const tasksEpic = combineEpics(
  beginLoading,
  endLoading,
  // getSingleEpic,
  getSingleMulti,
  processSingleEpic,
  getMultipleEpic,
  processMultipleEpic,
  getMoreEpic
);



// WEBPACK FOOTER //
// ./src/network/tasks.js